// Languages as stored in the database.
var Language;
(function (Language) {
    Language[Language["Afrikaans"] = 1] = "Afrikaans";
    Language[Language["Albanian"] = 43] = "Albanian";
    Language[Language["Arabic"] = 2] = "Arabic";
    Language[Language["Bengali"] = 4] = "Bengali";
    Language[Language["Bulgarian"] = 3] = "Bulgarian";
    Language[Language["Catalan"] = 5] = "Catalan";
    Language[Language["Chinese"] = 54] = "Chinese";
    Language[Language["ChineseTaiwan"] = 55] = "ChineseTaiwan";
    Language[Language["Croatian"] = 20] = "Croatian";
    Language[Language["Czech"] = 6] = "Czech";
    Language[Language["Danish"] = 8] = "Danish";
    Language[Language["Dutch"] = 33] = "Dutch";
    Language[Language["English"] = 11] = "English";
    Language[Language["Estonian"] = 13] = "Estonian";
    Language[Language["Finnish"] = 15] = "Finnish";
    Language[Language["French"] = 16] = "French";
    Language[Language["German"] = 9] = "German";
    Language[Language["Greek"] = 10] = "Greek";
    Language[Language["Gujarati"] = 17] = "Gujarati";
    Language[Language["Hebrew"] = 18] = "Hebrew";
    Language[Language["Hindi"] = 19] = "Hindi";
    Language[Language["Hungarian"] = 21] = "Hungarian";
    Language[Language["Indonesian"] = 22] = "Indonesian";
    Language[Language["Italian"] = 23] = "Italian";
    Language[Language["Japanese"] = 24] = "Japanese";
    Language[Language["Kannada"] = 25] = "Kannada";
    Language[Language["Korean"] = 26] = "Korean";
    Language[Language["Latvian"] = 28] = "Latvian";
    Language[Language["Lithuanian"] = 27] = "Lithuanian";
    Language[Language["Macedonian"] = 29] = "Macedonian";
    Language[Language["Malayalam"] = 30] = "Malayalam";
    Language[Language["Marathi"] = 31] = "Marathi";
    Language[Language["Nepali"] = 32] = "Nepali";
    Language[Language["Norwegian"] = 34] = "Norwegian";
    Language[Language["Panjabi"] = 35] = "Panjabi";
    Language[Language["Persian"] = 14] = "Persian";
    Language[Language["Polish"] = 36] = "Polish";
    Language[Language["Portuguese"] = 37] = "Portuguese";
    Language[Language["Romanian"] = 38] = "Romanian";
    Language[Language["Russian"] = 39] = "Russian";
    Language[Language["Slovak"] = 40] = "Slovak";
    Language[Language["Slovenian"] = 41] = "Slovenian";
    Language[Language["Somali"] = 42] = "Somali";
    Language[Language["Spanish"] = 12] = "Spanish";
    Language[Language["Swahili"] = 45] = "Swahili";
    Language[Language["Swedish"] = 44] = "Swedish";
    Language[Language["Tagalog"] = 49] = "Tagalog";
    Language[Language["Tamil"] = 46] = "Tamil";
    Language[Language["Telugu"] = 47] = "Telugu";
    Language[Language["Thai"] = 48] = "Thai";
    Language[Language["Turkish"] = 50] = "Turkish";
    Language[Language["Ukrainian"] = 51] = "Ukrainian";
    Language[Language["Urdu"] = 52] = "Urdu";
    Language[Language["Vietnamese"] = 53] = "Vietnamese";
    Language[Language["Welsh"] = 7] = "Welsh";
    Language[Language["Bosnian"] = 56] = "Bosnian";
    Language[Language["Serbian"] = 57] = "Serbian";
    Language[Language["Malay"] = 58] = "Malay";
    Language[Language["Icelandic"] = 102] = "Icelandic";
})(Language || (Language = {}));
export default Language;
//# sourceMappingURL=language.js.map